<template>
  <div class="setting-item">
    <el-form-item label="列配置项">
      <div v-for="(item, index) in columns" :key="index"
           class="setting-column_span">
        <el-input class="column-span_value"
                  placeholder="请输入栅格占据的列数" 
                  type="number" 
                  v-model.number="formMap[item.id].baseOption.span"></el-input>
        <i class="option-delete_button el-icon-minus" 
           @click="deleteColumn(item)"></i>
      </div>
      <el-button type="text" @click="addColumn">添加列</el-button>
    </el-form-item>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixValueWatch value监听混入
 *  @function mapComputed 计算属性映射方法
 *  @mixin mixRiceIndexChild 表单编辑页面store  
 */
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
import { mixRiceIndexChild } from '@/mixins/rice_index/mix_rice_index_child.js';


export default {
  mixins: [ mixValueWatch, mixRiceIndexChild ],
  /** @name 栅格列
   *  @description 将 columns 字段映射到当前 columns 计算属性
   *  @return {Array}
   *  @author 王汝鹏
   *  @version 2019-09-13
   */
  computed: {
    columns: {
      get() { return this.activeNode.children; }
    }
  },
  methods: {
    /** @name 删除栅格列
     *  @param {Object} node 删除节点 
     *  @author 王汝鹏
     *  @version 2019-09-13
     */
    deleteColumn(node) {
      // 删除节点
      this.formNodeManager(node).deleteFrom(this.columns);
    },
    /** @name 添加珊格列
     *  @author 王汝鹏
     *  @version 2019-09-13
     */
    addColumn() {
      // 添加 gridColumn 节点
      let columnFormNode = this.makeFormNodeConfig();
      this.activeNode.children.push(columnFormNode);
      let columnFormConfig = this.makeFormConfig('gridColumn');
      this.formConfigManager(columnFormConfig).setId(columnFormNode.id);
      this.formMap[columnFormNode.id] = columnFormConfig;
      this.formMap = {...this.formMap};
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingGridColumns.vue